export default {
  global: {
    parentTitle: 'Parent Portal',
    enter: 'Enter',
    back: 'Back',
    next: 'Next',
    backToSchedule: 'Back to Schedule page',
    backToCourse: 'Back to Course page',
    error: 'An error occurred.',
    trtAgain: 'Please try again.',
    noData: 'No Data',
    hLogo: 'LIVE Online',
    hLogoempty: 'AfterSchool Program',
    hPhoneNum: 'Phone Number',
    hDownload: 'Get Free Lesson!',
    select:'+1 U.S.A',
    name: 'kid(s) Nickname',
    phone: 'Phone Number',
    plase:'Phone Number',
    email: 'Email Address',
    wechat: 'WeChat ID',
    submit:'Submit',
  },
  index: {
    timeZone: 'Eastern Standard Time',
    profile: 'Profile',
    phone: 'Phone no.',
    location: 'Location',
    email: 'Email',
    referrer: 'Referrer',
    creditBalance: 'Credit Balance',
    topUp: 'Top Up',
    viewDetails: 'View Details',
    myChild: 'My Child',
    ofBirth: 'Date of Birth',
    editChild: 'Edit Child'
  },
  searchTabBar: {
    selectChild: 'Select Child',
    all: 'All',
    Showing: 'Showing:',
    scheduled: 'Scheduled Lesson',
    course: 'Course',
    completedLesson: 'Completed Lesson'
  },
  tabBar: {
    noLesson: 'No lesson is scheduled.',
    download: 'Download our TwinkleTalk apps to schedule a course.'
  },
  login: {
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    enterPassword: 'Enter password',
    confirmPassword: 'Confirm password',
    reset: 'Reset',
    savedPsw: 'New password is saved',
    backSign: 'Back to Sign In page'
  },
  signIn: {
    signIn: 'Sign In',
    register: 'Register',
    enterInfo: 'Enter your phone number to register',
    sentCode: 'A code will be sent to verify your phone.',
    phone: 'Phone Number',
    code: 'Send Code',
    verifiCode: 'Verification Code',
    repeatVerifiCode: 'Resend Code',
    second: 's',
    enter: 'Enter',
    enterPsw: 'Sign in with password',
    password: 'Password',
    forgetPassword: 'Forgot password',
    signIncode: 'Register/Sign in with verification code',
    searchArea: 'Search Area Code'
  },
  header: {
    resetPassword: 'Reset Password',
    logout: 'Logout',
    setting: 'Settings'
  },
  main: {
    topic: 'Lesson Topic:',
    attendee: 'Attendee:',
    viewFeedback: 'View Feedback',
    leaveFeeback: 'Leave Feedback',
    teacherComments: 'Teacher Comments',
    rating: 'Your Rating:',
    comment: 'Your Comment:',
    commentHere: 'Type your comment here',
    send: 'Send',
    sendSuccess: 'Feedback comment successful.',
    enterClassRoom: 'Enter Classroom',
    PresentationPreview: 'Presentation Preview',
    requestLeave: 'Cancelling A Course',
    leave: 'Leave',
    beginToEnter: 'Classroom will be opened 5 minutes before scheduled time.',
    timeOut: 'Start in ',
    timeOut_1:'',
    OnAir:'On Air',
    inProgress: 'In progress',
    noStart: 'Not Started',
    completed: 'Completed',
    cancel: 'Cancel',
    hours: ' hours ',
    hr:' hour ',
    mins: ' mins',
    sickTitle: 'Cancelling A Course',
    askTo: 'Are you sure you want to request a leave for ',
    currentCredit: ' ?',
    subject: 'Subject',
    date: 'Date',
    time: 'Time',
    confirmSick: 'Confirm Lave'
  },
  course: {
    nextLesson: 'Next lesson',
    viewCurriculum: 'View Curriculum',
    title: 'Course Curriculum',
    subjectDescription: 'Subject Description',
    levels: 'Levels',
    best: 'Best for',
    yearold: 'years old',
    lessonTopic: 'Lesson Topics',
    totalLesson: 'No. of lesson:'
  },
  email: {
    accountInfo: 'Account information',
    emailAddress: 'Email Address',
    referralCode: 'Referral Code (Optional)',
    entercode: 'Enter code',
    ParentFullName: 'Kid(s) Nickname',
    WechatID:'Wechat ID',
    nowechatname:'(no wechat name)',
    ReferredByFriend:'Referred by a friend?',
    FriendReferralPrograms:'Friend Referral Programs',
    EnterYourReferralCode:'Enter Your Referral Code',
    EnterCode:'Enter code',
    fail:'Recommendation code verification failed'


  },
  myChild: {
    addProfile: 'Add Profile',
    pickAvatar: 'Pick an Avatar',
    childName: 'Child’s Name',
    childBirth: 'Child’s Birthday',
    deleteChild: 'Delete Child',
    editProfile: 'Edit Profile',
    saveChange: 'Save Change',
    add: 'Add',
    edit: 'Edit',
    select: 'Select',
    name: 'Name',
    editChildProfile: 'Edit Children’s Profile',
    addChild: 'Add Child',
    editChild: 'Edit Profile',
    whoAttend: 'Who will be attending our lessons?',
    minimumChild: 'Mimimum 1 profile must be added to proceed.',
    sureToLeave: 'Are you sure to leave without saving your input?',
    sureToDelete: 'Are you sure to delete ',
    sureToWho: '’s Profile?',
    yes: 'Yes',
    no: 'No, go back',
    Next:'Next',
  },
  payment: {
    paySuccess: 'Payment Successful',
    payment: 'Payment',
    detail: 'Detail',
    price: 'Price:',
    credits: 'Credits:',
    backMain: 'Back to Main Page',
    hpayment: 'Payment',
    hdetail: 'Detail',
    hcredits: 'Credits:',
    hPayPlease: '*Please close the website',
    hPayGoBack: 'and go back to TwinkleTalk app',
    hPaySeeBalance: 'to see your new balance!'
  },
  payList: {
    creditTitle: 'Credit History',
    paymentTitle: 'Payment History',
    total: 'Total Credit Balance',
    date: 'Select a date',
    range: 'date range',
    dash: '/',
    reset: 'Reset filter',
    dateTitle: 'Date',
    description: 'Description',
    credits: 'Credit(s)',
    orderNo: 'Order no.',
    paid: 'Paid ($)'
  },
  recharge: {
    topup: 'Top Up Credits',
    currentCredit: 'My Current Credit Balance',
    manyCredit: 'How many credits woud you like to purchase?',
    selectPackage: 'Select a package below.',
    toPay: 'Proceed to Payment',
    empty: 'for',
    credits: 'credits',
    extra: 'Extra',
    free: 'free',
    hCurrentCredit: 'My Current Credit Balance:',
    hPay: 'Pay',
    hExtraCredits: ' extra credits ',
    hFree: 'FREE'
  },
  errorprompt: {
    selectAvatar: 'Please select avatar.',
    selectBirthday: 'Please select Child’s Birthday.',
    selectName: 'Please enter Child’s Name.',
    selectChild: 'Please select students.',
    phoneEmpty: 'Phone number cannot be empty.',
    phoneError: 'The phone number format is not correct.',
    nameEmpty: 'The parent full name cannot be empty.',
    wechatEmpty: 'The Wechat ID cannot be empty.',
    emailEmpty: 'The Email cannot be empty.',
    emailError: 'The Email format is not correct.',
    referralError: 'The Referral Code format is not correct.',
    emailBeSend: 'The email has been sent',
    passwordEmpty: 'The password cannot be empty.',
    passwordLessThan: 'The password must consist of at least seven digits and letters',
    passwordError: 'The password format is not correct.',
    currentpswEmpty: 'Current password cannot be empty.',
    currentpswError: 'Current password format is not correct.',
    newPswEmpty: 'New password cannot be empty.',
    newPswSameAs: 'New password cannot be the same as current password.',
    newPswError: 'New password format is not correct.',
    newPswDontSame: 'Both new passwords do not match.',
    del_1:'Are you sure to delete?',
    del_2:'Deleted successfully',
    del_3:'Confirm',
    del_4:'Cancel',
  },
  test2: {
    Next_class: 'NEXT LESSON',
    meet: 'MEET',
  },
  new_header:{
    Unlimited: 'Unlimited',
    information: 'Parent User Profile',
    TransactionOrderHistory: 'Transaction/Order History',
    MonthlyPassUser: 'Monthly Pass User',
    MonthyuStatement: 'Monthly Statement',
    Log_out: 'Log out'
  },
  new_index:{
    CurrentMonthLessons:'Current Month Lessons',
    Completed:'Completed',
    Scheduled:'Pending',
    NoShow:'No Show',
    Attend_Class_Now: 'Join Class',
    Class_Enrolled: 'My Course',
    View_Completed_Lessons: 'Past Lesson',
    Schedule_a_Class: 'Schedule a Class',
    Purchase_Lesson_Plan: 'Purchase Lesson Plan',
    Dear_customer:'Dear customer ',
    If:'If you would like to change your plan.' ,
    Please:'Please contact our customer service.',
    Address:'Address message',
    Videoclass:'Video Class',
    Homework:'Homework'
  },
  new_test1:{
    In_progress: 'In progress',
    Level: 'LEVEL',
    Topic: 'TOPIC',
    Type: 'CLASS TYPE',
  },
  new_test2:{
    Class_Enrolled: 'Course',
    In_progress: 'In progress',
    Not_Started: 'Not Started',
    Completed:'Completed',
    Level: 'LEVEL',
    Topic: 'TOPIC',
    Student: 'Student'
  },
  new_test3:{
    Level:'LEVEL',
    Topic:'TOPIC'
  },
  new_test4:{
    Schedule_a_Class:'Schedule a Class',
    Sch_content:'You also can find our live chat on TwinkleTalk parent APP for more informations.',
    Mandy:'Mandy',
    your:'Your course advisor',
    Wechat_ID: 'Wechat ID'
  },
  new_test5:{
    Pick_a_Plan: 'Pick a Plan',
    Number_of_Kids: 'Number of Kids',
    Pay_as_You_Go: 'Pay-as-You-Go',
    Continue: 'Continue',
    sessions:'sessions'
  },
  information:{
    Profile: 'Profile',
    Parent_Full_Time: 'Parent Full Time',
    Phone_no: 'Phone no.',
    Location: 'Location',
    Email: 'Email',
    Password: 'Password',
    Change: 'Change',
    Preferred_language:'Preferred language',
    editProfile: 'editProfile',
    English:'English',
    Simplified_Chinese:'中文（简体）'
  },
  Transaction: {
    History:'Transaction History',
    Order: 'Order No.',
    Date: 'Date',
    Description:'Class Hour',
    Paid:'Paid ($)',
    Status:'Status',
    Contract: 'Contract',
  },
  MonthlyPassUser: {
    Monthly_Pass_User: 'Monthly Pass User',
    Pass_Information:'Pass Information',
    kid:'kid(s)',
    Month:'month',
    Pass_Expires:'Pass Expires',
    Next_billing_date: 'Next Billing Date',
    view_charges: 'view charges',
    view_billing_history: 'view billing history',
    Payment_method: 'Payment Method',
    Mastercard_ending_in: 'Mastercard ending in',
    Update:'Update',
    Expires:'Expires',
    Changing:'Changing plan? Contact your Course advisor for assistance.',
    Wechat_ID: 'Wechat ID'
  },
  addChildren:{
    Edits:'Edit Children’s Profile',
    Childs_Name: 'Child’s Name',
    Child_Birthday: 'Child’s Birthday',
    add:'Add Child',
    Delete:'Delete',
    Edit:'Edit'
  },
  Change_Plan:{
    ChangePlan:'Change Plan',
    Current_Plan: 'Current Plan',
    year:'year',
    month:'month',
    New_Plan:'New Plan',
    Payment_method:'Payment method',
    Mastercard:'Mastercard ending in',
    Update: 'Update',
    Expires:'Expires',
    Change_Plan:'Change Plan',
    Months:'Months',
    kids:'kid(s)',
    What:'What happens next',
    Change_Plan: 'Change Plan'
  },
  Monthly:{
    Monthlys:'Monthly Statement',
    Date:'Date',
    studen:'Student(s)',
    class:'class',
    Class_size:'Class size',
    Credit:'Credit(s)',
    Requried:'Requried Credit(s)',
    Status:'Status',
    yue:'Select Date'
  },
  Payment:{
    Complete:'Complete Payment',
    Go_Back: 'Go Back',
    Personal_Infomation:'Personal Infomation',
    Payment_Method:'Payment Method',
    Pay_Now:'Pay Now',
    describe:'By continuing, I accept terms in the <span style="color:#4B69FE;text-decoration:underline;">Service Payment Agreement</span> including <span style="color:#4B69FE;text-decoration:underline;">Refund Policy</span>. I have read the <span style="color:#4B69FE;text-decoration:underline;">COPPA Direct Notice to Parent</span>. I agree to subscribe to TwinkleTalk newsletter, SMS messages, and accept the <span style="color:#4B69FE;text-decoration:underline;">Terms of Use</span> and <span style="color:#4B69FE;text-decoration:underline;">Privacy Policy</span>.',
  },
  pay_Success:{
    Go_Home: 'Go Home',
    Payment:'Payment successfull!',
    We:'We will contact you shortly.',
    You:'You will receive a confirmation email shortly.',
    Below: 'Below are the contact information for your course advisor Mandy.',
    Total: 'Total Today',
    month:'month',
    Best:'Best Value'
  },
  "Congratulation!":"Congratulation!",
  "You have a Special Offer!":"You have a Special Offer!",
  "You have":"You have",
  "Hours":"Hours",
    "Minutes":"Minutes",
    "Seconds":"Seconds",
   "Nomore":"No more transaction history",
   "reached":"You've reached the end of the list",
   sharefree:{
    educators:"500+ U.S K-12  top educators",
    sessions:"Over 20,000,000+ minutes live sessions",
    parents:"Trusted by 10,000+ parents",
    Match:"20+Subjects Mix and Match",
   },
   Childdialog:{
    Parent:"Dear Parent:",
    advisor:"If you want to add child, please contact our course advisor for assistant！",

   },
   "Country Code":"Country Code",
   "Please select your country code":"Please select your country code",

   "Sign in":"Sign in",
   "Please use Google Chrome or Microsoft Edge to improve your experience.":"Please use Google Chrome or Microsoft Edge to improve your experience.",
   "Verification Code":"Verification code",
   "Passwordon":"Password",
   "Phone number":"Phone number",
   "Verification code":"Verification code",
   "Password":"Password",
   "Send":"Send",
   "Continue":"Continue",
   "By continuing, you agree to our Terms of Use and Privacy Policy.":"By continuing, you agree to our Terms of Use and Privacy Policy.",
   "Welcome to TwinkleTalk":"Welcome to TwinkleTalk",
   "Please tell us a little about yourself":"Please tell us a little about yourself",
   "Phone Number":"Phone Number",
   "Kid(s) Nickname":"Kid(s) Nickname",
   "Email address":"Email address",
   "Wechat ID":"Wechat ID",
   "Submit":"Submit",
   "Thank you for choosing us":"Thank you for choosing us",
   "Your Course Adviser will contact you shortly":"Your Course Adviser will contact you shortly",
   "Back":"Back",
   "Please use":"Please use Google Chrome or Microsoft Edge to improve your experience.",
   "Please verify and enter the text in the picture":"Please verify and enter the text in the picture",
   "The Verification Code can not be empty":"The Verification Code can not be empty",
   "Please enter the contents":"Please enter the contents",
   "Success":"submit",
   "Click Refresh Verification Code":"Click Refresh Verification Code",
   "User Does Not Exist":"User does not exists, please try again",
   "Wrong password":"Wrong password, please try again",
   "Dont have an account":"Don’t have an account?",
   "Sign up to get a free lesson":"Sign up to get a free lesson",
   "Congratulations!":"Congratulations!",
    "You have claimed a free trial lesson":"You have claimed a free trial lesson",
   "Our Course Adviser will contact you shortly":"Our Course Adviser will contact you shortly",
   "Paid Credit":"Paid Credit",
   "Refundable":"Refundable",
   "Reward Credit":"Reward Credit",
   "Non-Refundable":"Non-Refundable",
   "For more information please read":"For more information please read",

}



// WEBPACK FOOTER //
// ./src/i18n/en-US.js